export default[
    {
        path: '/pacientes',
        component: () => import(/* webpackChunkName: "pacientes" */ '@/views/Pacientes.vue'),
        children:[
            {
                path:'/',
                name:'pacientesList',
                component: () => import(/* webpackChunkName: "pacientesList" */ '@/components/pacientes/PacientesList.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'id/:id',
                name:'pacienteDetalle',
                component: () => import(/* webpackChunkName: "hospitalInternamiento" */ '@/components/pacientes/PacienteDetalle.vue'),
                meta: {
                    requiresAuth: true,
                    //roles:['ROLE_ADMIN','ROLE_REFERENCIAS_USUARIO','ROLE_REFERENCIAS_ADMIN'],
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'edit/:id',
                name:'pacienteEdita',
                component: () => import(/* webpackChunkName: "hospitalInternamiento" */ '@/components/pacientes/PacienteNuevo.vue'),
                meta: {
                    requiresAuth: true,
                    //roles:['ROLE_ADMIN','ROLE_REFERENCIAS_USUARIO','ROLE_REFERENCIAS_ADMIN'],
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'create',
                name:'pacienteNuevo',
                component: () => import(/* webpackChunkName: "hospitalInternamiento" */ '@/components/pacientes/PacienteNuevo.vue'),
                meta: {
                    requiresAuth: true,
                    //roles:['ROLE_ADMIN','ROLE_REFERENCIAS_USUARIO','ROLE_REFERENCIAS_ADMIN'],
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'defunciones',
                name:'pacienteDefunciones',
                component: () => import(/* webpackChunkName: "hospitalInternamiento" */ '@/components/pacientes/PacientesDefuncionList.vue'),
                meta: {
                    requiresAuth: true,
                    //roles:['ROLE_ADMIN','ROLE_REFERENCIAS_USUARIO','ROLE_REFERENCIAS_ADMIN'],
                    roles:['ROLE_PACIENTES'],
                },
            },
        ]
    }
]